import { useState } from "react";
import { FilterActionsFooter } from "@design-system/Filter/FilterActionsFooter/FilterActionsFooter";
import { Checkbox } from "@design-system/Checkbox/Checkbox";
import { BooleanControl } from "./playgroundControls";
import { SandboxLayout } from "./SandboxLayout";
import { ShowcasePreview } from "./ShowcasePreview";
import layoutStyles from "./DatePickerPlayground.module.scss";
import styles from "./FiltersToolbarPlayground.module.scss";

const accounts = [
    { id: "checking", label: "Operating checking · 2841" },
    { id: "card", label: "Corporate card · 9012" },
    { id: "stripe", label: "Stripe clearing" },
    { id: "savings", label: "Tax savings · 7730" },
];

export const FilterActionsFooterPlayground = () => {
    const [selectedAccountIds, setSelectedAccountIds] = useState<string[]>([
        "checking",
        "card",
    ]);
    const [appliedAccountIds, setAppliedAccountIds] = useState<string[]>([
        "checking",
        "card",
    ]);
    const [isDisabled, setIsDisabled] = useState(false);
    const [hasReverseAction, setHasReverseAction] = useState(true);
    const [isBorderAndPaddingHidden, setIsBorderAndPaddingHidden] =
        useState(false);

    const toggleAccount = (accountId: string) => {
        setSelectedAccountIds((currentIds) =>
            currentIds.includes(accountId)
                ? currentIds.filter((id) => id !== accountId)
                : [...currentIds, accountId],
        );
    };

    const reverseSelection = () => {
        setSelectedAccountIds((currentIds) =>
            accounts
                .map((account) => account.id)
                .filter((id) => !currentIds.includes(id)),
        );
    };

    return (
        <SandboxLayout
            controls={
                <section>
                    <h2>Features</h2>
                    <div className={layoutStyles.booleanGrid}>
                        <BooleanControl
                            label="Disabled"
                            checked={isDisabled}
                            onChange={setIsDisabled}
                        />
                        <BooleanControl
                            label="Reverse action"
                            checked={hasReverseAction}
                            onChange={setHasReverseAction}
                        />
                        <BooleanControl
                            label="Hide border and padding"
                            checked={isBorderAndPaddingHidden}
                            onChange={setIsBorderAndPaddingHidden}
                        />
                    </div>
                </section>
            }
        >
            <ShowcasePreview
                summary={`${selectedAccountIds.length} accounts selected`}
                output={JSON.stringify(
                    {
                        props: {
                            selectedCount: selectedAccountIds.length,
                            disabled: isDisabled,
                            hideBorderAndPadding: isBorderAndPaddingHidden,
                            hasReverseFunction: hasReverseAction,
                        },
                        showcaseState: {
                            appliedAccountIds,
                        },
                    },
                    null,
                    2,
                )}
            >
                <div className={styles.filterPanel}>
                    <div className={styles.filterContent}>
                        <h2 className={styles.filterTitle}>
                            Filter by account
                        </h2>
                        {accounts.map((account) => (
                            <Checkbox
                                key={account.id}
                                label={account.label}
                                checked={selectedAccountIds.includes(
                                    account.id,
                                )}
                                onCheckedChange={() =>
                                    toggleAccount(account.id)
                                }
                                disabled={isDisabled}
                            />
                        ))}
                        <p className={styles.filterSummary}>
                            Applied filter:{" "}
                            {appliedAccountIds.length
                                ? `${appliedAccountIds.length} accounts`
                                : "all accounts"}
                        </p>
                    </div>
                    <FilterActionsFooter
                        selectedCount={selectedAccountIds.length}
                        deselectFunction={() => setSelectedAccountIds([])}
                        reverseFunction={
                            hasReverseAction ? reverseSelection : undefined
                        }
                        applyFunction={() =>
                            setAppliedAccountIds(selectedAccountIds)
                        }
                        disabled={isDisabled}
                        hideBorderAndPadding={isBorderAndPaddingHidden}
                    />
                </div>
            </ShowcasePreview>
        </SandboxLayout>
    );
};
